import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

/* Remaining purchase limit for the product on show.
   Pass productBudget and productId when the product is not the one held in the
   store, as the quick buy dialog does. The listing page fetches spend for every
   product at once, so it has to be narrowed to this one.
   hasLimit is false when no limit is configured for the product or the visitor
   is not logged in - the cases where the limit is not shown at all. */
const usePurchaseLimit = (productBudget, productId) => {
  const isNotLoggedIn = sessionStorage.getItem("login") !== "true";

  const productReducer = useSelector((state) => state.productReducer);
  const customerProductData = useSelector(
    (state) => state.customerProductReducer?.getCustomerProduct
  );
  const purchaseLimitType = useSelector(
    (state) =>
      state.clientConfigurationReducer?.clientConfigurationData[0]
        ?.purchaseLimitType
  );

  const [purchasedLimit, setPurchasedLimit] = useState({
    productLimit: 0,
    totalPurchasedValue: 0,
  });

  useEffect(() => {
    const purchaseLimitTypeList = purchaseLimitType
      ?.split(",")
      ?.map((type) => type?.trim()?.toLowerCase())
      ?.filter(Boolean);

    const limits =
      productBudget?.limits ?? productReducer?.data?.[0]?.productBudget?.limits;
    const totalLimit = limits?.find((item) =>
      purchaseLimitTypeList?.includes(item?.limitType?.toLowerCase())
    );

    if (Array.isArray(customerProductData)) {
      const spendForProduct = productId
        ? customerProductData.filter(
            (item) => String(item?.productIdentifier) === String(productId)
          )
        : customerProductData;
      const limitByType = spendForProduct?.find((item) =>
        purchaseLimitTypeList?.includes(item?.limitType?.toLowerCase())
      );

      setPurchasedLimit({
        ...limitByType,
        productLimit: totalLimit?.limitValue,
      });
    } else {
      setPurchasedLimit({
        productLimit: totalLimit?.limitValue,
        totalPurchasedValue: 0,
      });
    }
  }, [
    customerProductData,
    purchaseLimitType,
    productReducer,
    productBudget,
    productId,
  ]);

  const hasLimit = Boolean(purchasedLimit.productLimit) && !isNotLoggedIn;

  return {
    hasLimit,
    remaining:
      purchasedLimit?.productLimit -
      (purchasedLimit?.totalPurchasedValue || 0),
  };
};

export default usePurchaseLimit;
